import React, { useEffect, useState } from 'react';
import { Redirect, useHistory } from 'react-router';

import { getCurrentPath, getMatchPageUrl } from '../utils';

export const MatchRedirect = () => {
  const { location: { pathname } } = useHistory();
  const currentPath = getCurrentPath(pathname);
  const [redirectPath, setRedirectPath] = useState<string | null>(null);

  useEffect(() => {
    getMatchPageUrl(currentPath).then((pageUrl) => setRedirectPath(pageUrl));
  }, [redirectPath]);

  if (!redirectPath) {
    return null;
  }

  return (
    <Redirect to={`/${redirectPath}`} />
  );
};
